import React from 'react'
import { Navbar, Footer } from "../../components"
import { Subscribe } from "."
export default function SolarSubscribe() {
  return (
    <div className='emas__signup'>
        <Navbar />
        <Subscribe />
        <Footer />
    </div>
  )
}
